<script>
import { mapGetters } from 'vuex';
import ModalCloseButton from './ModalCloseButton';

export default {
  name: 'SavePresetModal',
  components: {
    ModalCloseButton,
  },
  props: {
    env: {
      type: String,
      default: () => 'prod',
      validator: value => {
        return ['prod', 'dev', 'staging'].indexOf(value) !== -1;
      },
    },
  },
  data: () => {
    return {
      presetName: '',
      showErrorMsg: false,
      showSameNameErrorMsg: false,
    };
  },
  computed: {
    ...mapGetters({
      presetData: 'FormFinder/getPresetData',
      isLoading: 'FormFinder/getLoadingStatus',
    }),
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_MODAL_STATUS', { showModal: false });
    },
    isInputEmpty() {
      if (this.presetName) {
        this.showErrorMsg = true;
        this.showSameNameErrorMsg = false;
        return false;
      } else {
        return true;
      }
    },
    async savePreset() {
      const { presetName, env, $store, presetData } = this;
      const { dispatch, commit } = $store;
      const isInputEmpty = this.isInputEmpty();
      if (!isInputEmpty) {
        const presetWithSameName = presetData.filter(data => data.name === presetName);
        if (presetWithSameName.length === 1) {
          this.showSameNameErrorMsg = true;
          this.showErrorMsg = false;
        }

        if (presetWithSameName.length === 0) {
          this.showErrorMsg = false;
          this.showSameNameErrorMsg = false;
          commit('SET_LOADING_STATUS', { isLoading: true });
          await dispatch('FormFinder/addPresetData', { env, presetName });
          await dispatch('FormFinder/fetchPresetData', { env });
        }
      }
    },
  },
};
</script>

<template>
  <div class="save-preset-modal-wrap">
    <div class="save-preset-modal__header">
      <div class="save-preset-modal__title">Save Form Finder Settings</div>
    </div>
    <div v-if="isLoading" class="save-preset-modal__main">
      <label class="save-preset-modal__main-text" for="predictor-input">Saving Preset ...</label>
    </div>
    <div v-if="!isLoading" class="save-preset-modal__main">
      <label class="save-preset-modal__main-text" for="predictor-input">Name Form Finder Preset</label>
      <input
        id="predictor-input"
        v-model.trim="presetName"
        class="save-preset-modal__input"
        placeholder="eg: Best at Track + Distance"
      >

      <span
        v-show="showErrorMsg"
        class="save-preset-modal__error-msg error-msg--no-name"
      >Please enter a name.</span>
      <span
        v-show="showSameNameErrorMsg"
        class="save-preset-modal__error-msg error-msg--same-name"
      >Preset with this name already exists.</span>
    </div>
    <div v-if="!isLoading" class="save-preset-modal__footer">
      <button class="save-preset-modal__footer-btn footer-btn--cancel" @click="closeModal">Cancel</button>
      <button class="save-preset-modal__footer-btn footer-btn--save" @click="savePreset">Save</button>
    </div>
    <ModalCloseButton />
  </div>
</template>
